module.exports = __webpack_public_path__ + "img/electronic_fence.50ee0365.png";